var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"matriz",attrs:{"width":"750","height":"700"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }